
const presetData = {
    contactUs: [
        {
            "id": "text-input-1717394697519",
            "name": "fullname",
            "label": "Name",
            "type": "text",
            "placeholder": "Enter name...",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717394697519"
        },
        {
            "id": "email-input-1717394698704",
            "name": "email",
            "label": "Email",
            "type": "email",
            "placeholder": "Enter email...",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "email",
            "isNew": "old",
            "uniqueId": "field-1717394698704"
        },
        {
            "id": "text-field-1717394700673",
            "name": "address",
            "label": "Address",
            "type": "text",
            "placeholder": "",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717394700673"
        },
        {
            "id": "radio-button-1717398710789",
            "className": "radio-inputs",
            "label": "Gender",
            "type": "radio",
            "required": false,
            "name": "gender",
            "pro": "pro-inactive",
            "profeature": "false",
            "isNew": "old",
            "options": [
                {
                    "label": "Male",
                    "value": "male"
                },
                {
                    "label": "Female",
                    "value": "female"
                }
            ],
            "subtype": "radio",
            "uniqueId": "field-1717398710789"
        }
    ],
    // Define other presets as needed

    WhatsApp: [
        // JSON structure for WhatsApp Form
        {
            "id": "text-input-1717398163944",
            "name": "name-text-input-1717398163944",
            "label": "What is your name?",
            "type": "text",
            "placeholder": "Enter name",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717398163944"
        },
        {
            "id": "number-input-1717398175615",
            "name": "number-text-input-1717398175615",
            "label": "Phone number",
            "type": "number",
            "placeholder": "Enter mobile no",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "value": "",
            "isNew": "old",
            "uniqueId": "field-1717398175615"
        },
        {
            "id": "email-input-1717398193737",
            "name": "email-text-input-1717398193737",
            "label": "Email",
            "type": "email",
            "placeholder": "Enter email...",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "email",
            "isNew": "old",
            "uniqueId": "field-1717398193737"
        }
    ],
    Support: [
        {
            "label": "Heading",
            "content": "How can we help?",
            "id": "heading-input-1717396828503",
            "name": "heading-text-input-1717396828503",
            "type": "heading",
            "headingtype": "h3",
            "className": "heading-input",
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "heading",
            "isNew": "old",
            "uniqueId": "field-1717396828503"
        },
        {
            "label": "label",
            "id": "label-input-1717396888229",
            "name": "label-text-input-1717396888229",
            "type": "label",
            "className": "label-input",
            "for": "",
            "content": "We usually respond within 1 hour, but it may be a bit longer when weekend.",
            "value": "",
            "pro": "pro-inactive",
            "profeature": "false",
            "subtype": "label",
            "isNew": "old",
            "uniqueId": "field-1717396888229",
        },
        {
            "id": "select-input-1717396919710",
            "className": "select-inputs",
            "name": "select-input-1717396919710",
            "label": "-- Please choose an options --",
            "type": "select",
            "required": false,
            "pro": "pro-inactive",
            "isNew": "old",
            "profeature": "false",
            "options": [
                {
                    "label": "Pre-sale query",
                    "value": "Pre-sale query"
                },
                {
                    "label": "Products support",
                    "value": "Products support"
                },
                {
                    "label": "Feature request",
                    "value": "Feature request"
                },
                {
                    "label": "Refund request",
                    "value": "Refund request"
                }
            ],
            "uniqueId": "field-1717396919710"
        },
        {
            "id": "select-input-1717397023674",
            "className": "select-inputs",
            "name": "select-input-1717397023674",
            "label": "-- Please choose product -- ",
            "type": "select",
            "required": false,
            "pro": "pro-inactive",
            "isNew": "old",
            "profeature": "false",
            "options": [
                {
                    "label": "Product 1",
                    "value": "Product 1"
                },
                {
                    "label": "Product 2",
                    "value": "Product 2"
                }
            ],
            "uniqueId": "field-1717397023674"
        },
        {
            "id": "text-input-1717397129721",
            "name": "name-text-input-1717397129721",
            "label": "Your full name",
            "type": "text",
            "placeholder": "Full name",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717397129721"
        },
        {
            "id": "url-input-1717397194868",
            "name": "url-text-input-1717397194868",
            "label": "Website URL",
            "type": "url",
            "placeholder": "Enter url...",
            "className": "url-field",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "url",
            "isNew": "old",
            "uniqueId": "field-1717397194868"
        },
        {
            "id": "email-input-1717397204706",
            "name": "email-text-input-1717397204706",
            "label": "Email address",
            "type": "email",
            "placeholder": "Enter email...",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "email",
            "isNew": "old",
            "uniqueId": "field-1717397204706"
        },
        {
            "id": "text-area-1717397229868",
            "name": "textarea-text-input-1717397229868",
            "label": "Message",
            "type": "textarea",
            "placeholder": "Add your queries",
            "className": "custom-input-text-area",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "textarea",
            "isNew": "old",
            "uniqueId": "field-1717397229868"
        }

    ],
    multiStep: [
        {
            "id": "text-input-1717398163944",
            "name": "name-text-input-1717398163944",
            "label": "What is your name?",
            "type": "text",
            "placeholder": "Enter name here",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717398163944"
        },
        {
            "id": "number-input-1717398175615",
            "name": "number-text-input-1717398175615",
            "label": "Phone number",
            "type": "number",
            "placeholder": "Enter mobile no",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "value": "",
            "isNew": "old",
            "uniqueId": "field-1717398175615"
        },
        {
            "id": "email-input-1717398193737",
            "name": "email-text-input-1717398193737",
            "label": "Email*",
            "type": "email",
            "placeholder": "Enter your Email",
            "className": "custom-input",
            "required": "true",
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "email",
            "isNew": "old",
            "uniqueId": "field-1717398193737"
        },
        {
            "id": "text-input-1717398283013",
            "name": "name-text-input-1717398283013",
            "label": "Age",
            "type": "text",
            "placeholder": "age",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717398283013"
        },
        {
            "id": "page_break_id-1717398293117",
            "name": "page_break_name-1717398293117",
            "label": "Page Break",
            "type": "page_break",
            "required": false,
            "subtype": "page_break",
            "pro": "pro-inactive",
            "profeature": "false",
            "isNew": "old",
            "uniqueId": "field-1717398293117"
        },
        {
            "id": "text-field-1717398433332",
            "name": "textfield-text-input-1717398433332",
            "label": "Address *",
            "type": "text",
            "placeholder": "",
            "className": "custom-input",
            "required": "true",
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717398433332"
        },
        {
            "id": "text-area-1717398445518",
            "name": "textarea-text-input-1717398445518",
            "label": "Apartment or suite (optional)",
            "type": "textarea",
            "placeholder": "",
            "className": "custom-input-text-area",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "textarea",
            "isNew": "old",
            "uniqueId": "field-1717398445518"
        },
        {
            "id": "text-input-1717398468131",
            "name": "name-text-input-1717398468131",
            "label": "City*",
            "type": "text",
            "placeholder": "Enter city...",
            "className": "custom-input",
            "required": "true",
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717398468131"
        },
        {
            "id": "text-input-1717398476883",
            "name": "name-text-input-1717398476883",
            "label": "State*",
            "type": "text",
            "placeholder": "Enter state...",
            "className": "custom-input",
            "required": "true",
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717398476883"
        },
        {
            "id": "number-input-1717398498180",
            "name": "number-text-input-1717398498180",
            "label": "Postal code*",
            "type": "number",
            "placeholder": "Enter postal code...",
            "className": "custom-input",
            "required": "true",
            "pro": "pro-inactive",
            "value": "",
            "isNew": "old",
            "uniqueId": "field-1717398498180"
        },
        {
            "id": "page_break_id-1717398538696",
            "name": "page_break_name-1717398538696",
            "label": "Page Break",
            "type": "page_break",
            "required": false,
            "subtype": "page_break",
            "pro": "pro-inactive",
            "profeature": "false",
            "isNew": "old",
            "uniqueId": "field-1717398538696"
        },
        {
            "id": "checkbox-1717398556387",
            "className": "checkbox-inputs",
            "label": "Would you recommend our service to a friend?",
            "type": "checkbox",
            "name": "checkbox-button-1717398556387",
            "toggle": false,
            "required": false,
            "pro": "pro-inactive",
            "profeature": "false",
            "isNew": "old",
            "options": [
                {
                    "label": " Definitely",
                    "value": "Yes"
                },
                {
                    "label": "Maybe",
                    "value": "maybe"
                },
                {
                    "label": "Not sure",
                    "value": "no"
                }
            ],
            "uniqueId": "field-1717398556387"
        },
        {
            "id": "text-area-1717398619233",
            "name": "textarea-text-input-1717398619233",
            "label": "Any comments or suggestions?",
            "type": "textarea",
            "placeholder": "",
            "className": "custom-input-text-area",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "textarea",
            "isNew": "old",
            "uniqueId": "field-1717398619233"
        }
    ],
    Survey: [
        {
            "id": "text-input-1717398163944",
            "name": "name-text-input-1717398163944",
            "label": "What is your name?",
            "type": "text",
            "placeholder": "Enter name here",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717398163944"
        },
        {
            "id": "number-input-1717398175615",
            "name": "number-text-input-1717398175615",
            "label": "Phone number",
            "type": "number",
            "placeholder": "Enter mobile no",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "value": "",
            "isNew": "old",
            "uniqueId": "field-1717398175615"
        },
        {
            "id": "email-input-1717398193737",
            "name": "email-text-input-1717398193737",
            "label": "Email*",
            "type": "email",
            "placeholder": "Enter your Email",
            "className": "custom-input",
            "required": "true",
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "email",
            "isNew": "old",
            "uniqueId": "field-1717398193737"
        },
        {
            "id": "text-input-1717398283013",
            "name": "name-text-input-1717398283013",
            "label": "Age",
            "type": "text",
            "placeholder": "age",
            "className": "custom-input",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717398283013"
        },
        {
            "id": "page_break_id-1717398293117",
            "name": "page_break_name-1717398293117",
            "label": "Page Break",
            "type": "page_break",
            "required": false,
            "subtype": "page_break",
            "pro": "pro-inactive",
            "profeature": "false",
            "isNew": "old",
            "uniqueId": "field-1717398293117"
        },
        {
            "id": "text-field-1717398433332",
            "name": "textfield-text-input-1717398433332",
            "label": "Address *",
            "type": "text",
            "placeholder": "",
            "className": "custom-input",
            "required": "true",
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717398433332"
        },
        {
            "id": "text-area-1717398445518",
            "name": "textarea-text-input-1717398445518",
            "label": "Apartment or suite (optional)",
            "type": "textarea",
            "placeholder": "",
            "className": "custom-input-text-area",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "textarea",
            "isNew": "old",
            "uniqueId": "field-1717398445518"
        },
        {
            "id": "text-input-1717398468131",
            "name": "name-text-input-1717398468131",
            "label": "City*",
            "type": "text",
            "placeholder": "Enter city...",
            "className": "custom-input",
            "required": "true",
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717398468131"
        },
        {
            "id": "text-input-1717398476883",
            "name": "name-text-input-1717398476883",
            "label": "State*",
            "type": "text",
            "placeholder": "Enter state...",
            "className": "custom-input",
            "required": "true",
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "text",
            "isNew": "old",
            "uniqueId": "field-1717398476883"
        },
        {
            "id": "number-input-1717398498180",
            "name": "number-text-input-1717398498180",
            "label": "Postal code*",
            "type": "number",
            "placeholder": "Enter postal code...",
            "className": "custom-input",
            "required": "true",
            "pro": "pro-inactive",
            "value": "",
            "isNew": "old",
            "uniqueId": "field-1717398498180"
        },
        {
            "id": "page_break_id-1717398538696",
            "name": "page_break_name-1717398538696",
            "label": "Page Break",
            "type": "page_break",
            "required": false,
            "subtype": "page_break",
            "pro": "pro-inactive",
            "profeature": "false",
            "isNew": "old",
            "uniqueId": "field-1717398538696"
        },
        {
            "id": "checkbox-1717398556387",
            "className": "checkbox-inputs",
            "label": "Would you recommend our service to a friend?",
            "type": "checkbox",
            "name": "checkbox-button-1717398556387",
            "toggle": false,
            "required": false,
            "pro": "pro-inactive",
            "profeature": "false",
            "isNew": "old",
            "options": [
                {
                    "label": " Definitely",
                    "value": "Yes"
                },
                {
                    "label": "Maybe",
                    "value": "maybe"
                },
                {
                    "label": "Not sure",
                    "value": "no"
                }
            ],
            "uniqueId": "field-1717398556387"
        },
        {
            "id": "text-area-1717398619233",
            "name": "textarea-text-input-1717398619233",
            "label": "Any comments or suggestions?",
            "type": "textarea",
            "placeholder": "",
            "className": "custom-input-text-area",
            "required": true,
            "pro": "pro-inactive",
            "profeature": "false",
            "value": "",
            "subtype": "textarea",
            "isNew": "old",
            "uniqueId": "field-1717398619233"
        }
    ]


};

export default presetData;
